import Icon from 'components/shared/Icon/Icon';

import PracticeLetterhead from '../PracticeLetterhead';
import RequiredDisclosure from '../RequiredDisclosure';

import TotalPage from './components/TotalPage';
import WelcomePage from './components/WelcomePage';
import ServicesPage from './components/ServicesPage';
import DeductiblePage from './components/DeductiblePage';
import DefinitionsPage from './components/DefinitionsPage';
import DentalTotalPage from './components/DentalTotalPage';
import MaximumCheckPage from './components/MaximumCheckPage';
import AllowedAmountPage from './components/AllowedAmountPage';
import CoveredServicePage from './components/CoveredServicePage';
import DentalCoveragePage from './components/DentalCoveragePage';

const getSections = (vertical) => [
  { label: 'Welcome', component: WelcomePage },
  { label: 'Services', component: ServicesPage },
  { label: 'Coverage', component: CoveredServicePage },
  { label: 'Coverage', component: MaximumCheckPage },
  { label: 'Coverage', component: DeductiblePage },
  {
    label: 'Your Balance',
    component: vertical === 'dental' ? DentalCoveragePage : AllowedAmountPage
  },
  { label: 'Your Balance', component: vertical === 'dental' ? DentalTotalPage : TotalPage },
  { label: 'Definitions', component: DefinitionsPage }
];

const SectionDivider = ({ label }) => (
  <div className="flex items-center gap-4 py-2">
    <div className="h-px flex-1 bg-gradient-to-r from-transparent via-primary-200 to-transparent" />
    <div className="flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5">
      <Icon icon="arrow-down-mono" size={12} color="primary" />
      <span className="text-sm font-600 text-primary-500">{label}</span>
    </div>
    <div className="h-px flex-1 bg-gradient-to-r from-transparent via-primary-200 to-transparent" />
  </div>
);

const DrClearCare = ({ estimate, practice }) => (
  <div className="h-full overflow-y-auto bg-white">
    <div data-pdf-block>
      <PracticeLetterhead practice={practice} />
    </div>
    <div className="mx-auto flex w-full max-w-[720px] flex-col px-6 py-6">
      {getSections(estimate?.vertical).map((section, index) => {
        const SectionComponent = section.component;
        return (
          <div key={section.label + index} data-pdf-block>
            {index > 0 && <SectionDivider label={section.label} />}
            <div className="py-4">
              <SectionComponent estimate={estimate} />
            </div>
          </div>
        );
      })}
    </div>
    <div data-pdf-block>
      <RequiredDisclosure />
    </div>
  </div>
);

export default DrClearCare;
